"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2026.08.10.)
 * RTL 2021 API (2026.08.10.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteDataFromJSON = VoteDataFromJSON;
exports.VoteDataFromJSONTyped = VoteDataFromJSONTyped;
exports.VoteDataToJSON = VoteDataToJSON;
exports.VoteDataToJSONTyped = VoteDataToJSONTyped;
const runtime_1 = require("../runtime");
const _1 = require("./");
function VoteDataFromJSON(json) {
    return VoteDataFromJSONTyped(json, false);
}
function VoteDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': !(0, runtime_1.exists)(json, 'email') ? undefined : json['email'],
        'answers': !(0, runtime_1.exists)(json, 'answers') ? undefined : (json['answers'].map(_1.VoteAnswerResultFromJSON)),
    };
}
function VoteDataToJSON(value) {
    return VoteDataToJSONTyped(value, false);
}
function VoteDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'answers': value.answers === undefined ? undefined : (value.answers.map(_1.VoteAnswerResultToJSON)),
    };
}
